// extracted by mini-css-extract-plugin
export var btn = "style-module--btn--fcbab";
export var content = "style-module--content--eac71";
export var desc = "style-module--desc--6fa40";
export var final = "style-module--final--bca25";
export var icon = "style-module--icon--abebf";
export var order = "style-module--order--3d1fc";